// Mock data for PulseFit Studio

export const mockData = {
  // Hero section data
  hero: {
    headline: "Stronger Every Day.",
    subheader: "Join PulseFit Studio and transform your body and mind with expert-led workouts.",
    primaryCTA: "Book Your Free Class",
    secondaryCTA: "View Class Schedule",
    backgroundImage: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48"
  },

  // About section data
  about: {
    headline: "Fitness Designed for Every Body.",
    description: "At PulseFit, we believe fitness should be accessible, fun, and results-driven. Our expert trainers and supportive community keep you motivated every step of the way.",
    image: "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5"
  },

  // Programs data
  programs: [
    {
      id: 1,
      title: "Personal Training",
      description: "Tailored one-on-one coaching designed specifically for your fitness goals and lifestyle.",
      image: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61",
      icon: "User"
    },
    {
      id: 2,
      title: "Group Classes",
      description: "High-energy sessions for all fitness levels with supportive community atmosphere.",
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b",
      icon: "Users"
    },
    {
      id: 3,
      title: "Yoga & Wellness",
      description: "Balance your mind and body with mindful movement and meditation practices.",
      image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773",
      icon: "Heart"
    }
  ],

  // Schedule data
  schedule: {
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    timeSlots: ["6:00 AM", "7:30 AM", "9:00 AM", "10:30 AM", "5:30 PM", "7:00 PM"],
    classes: {
      "Monday": [
        { time: "6:00 AM", name: "Morning HIIT", type: "HIIT", trainer: "Sarah" },
        { time: "7:30 AM", name: "Vinyasa Flow", type: "Yoga", trainer: "Maya" },
        { time: "9:00 AM", name: "Strength Training", type: "Strength", trainer: "Marcus" },
        { time: "5:30 PM", name: "Cardio Blast", type: "Cardio", trainer: "Lisa" },
        { time: "7:00 PM", name: "Restorative Yoga", type: "Yoga", trainer: "Maya" }
      ],
      "Tuesday": [
        { time: "6:00 AM", name: "Bootcamp", type: "HIIT", trainer: "Marcus" },
        { time: "9:00 AM", name: "Power Yoga", type: "Yoga", trainer: "Sarah" },
        { time: "10:30 AM", name: "Pilates Core", type: "Strength", trainer: "Lisa" },
        { time: "5:30 PM", name: "Spin Class", type: "Cardio", trainer: "Jake" },
        { time: "7:00 PM", name: "Evening Flow", type: "Yoga", trainer: "Maya" }
      ],
      // Add more days...
    },
    filters: ["All", "Yoga", "Strength", "HIIT", "Cardio"]
  },

  // Pricing data
  pricing: [
    {
      id: 1,
      name: "Basic",
      price: "49",
      period: "month",
      description: "Perfect for getting started with fitness",
      features: [
        "2 classes per week",
        "Access to gym equipment",
        "Basic fitness assessment",
        "Mobile app access"
      ],
      popular: false
    },
    {
      id: 2,
      name: "Unlimited",
      price: "89",
      period: "month",
      description: "Most popular choice for serious fitness",
      features: [
        "Unlimited classes",
        "Access to all equipment",
        "Monthly progress tracking",
        "Priority class booking",
        "Guest pass (2 per month)"
      ],
      popular: true
    },
    {
      id: 3,
      name: "Premium",
      price: "149",
      period: "month",
      description: "Complete wellness transformation",
      features: [
        "Everything in Unlimited",
        "4 Personal training sessions",
        "Nutrition coaching",
        "Meal planning guide",
        "24/7 trainer support"
      ],
      popular: false
    }
  ],

  // Testimonials data
  testimonials: [
    {
      id: 1,
      name: "Sofia L.",
      text: "PulseFit changed my life. The trainers are incredible, and the energy is unmatched. I've never felt stronger!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786"
    },
    {
      id: 2,
      name: "Michael R.",
      text: "The community here is amazing. Every workout feels like a celebration with friends who push you to be your best.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    {
      id: 3,
      name: "Emma K.",
      text: "I love the variety of classes and how welcoming everyone is. The yoga sessions have transformed my mental health too.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
    }
  ],

  // Final CTA data
  finalCTA: {
    headline: "Your Transformation Starts Today.",
    ctaText: "Join PulseFit Now",
    backgroundImage: "https://images.pexels.com/photos/917732/pexels-photo-917732.jpeg"
  },

  // Footer data
  footer: {
    logo: "PulseFit Studio",
    tagline: "Fitness designed for every body",
    links: {
      classes: ["Group Classes", "Personal Training", "Yoga & Wellness", "Class Schedule"],
      studio: ["About Us", "Our Trainers", "Facilities", "Blog"],
      support: ["Contact", "FAQ", "Membership", "Pricing"]
    },
    contact: {
      address: "123 Fitness Street, Wellness City, WC 12345",
      phone: "+1 (555) 123-4567",
      email: "hello@pulsefitstudio.com"
    },
    socialMedia: ["facebook", "instagram", "twitter", "youtube"]
  }
};

// Mock booking function
export const mockBooking = {
  bookClass: (classData) => {
    console.log("Mock booking:", classData);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true, bookingId: Math.random().toString(36).substr(2, 9) });
      }, 1000);
    });
  },

  subscribePlan: (planData) => {
    console.log("Mock subscription:", planData);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true, subscriptionId: Math.random().toString(36).substr(2, 9) });
      }, 1500);
    });
  },

  submitContact: (contactData) => {
    console.log("Mock contact submission:", contactData);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true, messageId: Math.random().toString(36).substr(2, 9) });
      }, 800);
    });
  }
};